// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vue-app-container[data-v-7ba5bd90] {\n  padding: 5.25rem 1rem 0 4.24rem;\n}\n@media screen and (max-width: 768px) {\n.vue-app-container[data-v-7ba5bd90] {\n    padding: 5.25rem 1rem 0 1rem;\n}\n.vue-app-container .wc-econt-navbar[data-v-7ba5bd90] {\n    right: 0;\n}\n}", ""]);
// Exports
module.exports = exports;
